<template>
    <v-card>
        <div style="display: flex;">
            <div>
                <v-card-title>{{ count }} Tickets</v-card-title>
            </div>
        </div>
        <v-data-table
            :headers="headers"
            :items="list"
            :options.sync="options"
            :server-items-length="count"
            :loading="loading"
            >
            <!-- eslint-disable-next-line -->
            <template v-slot:item.general="{ item }">
                <v-chip small color="primary" label @click="openTicket(item)">
                    {{ item.control }}
                    <v-icon class="ml-2" small>mdi-eye</v-icon>
                </v-chip>
            </template>
            <!-- eslint-disable-next-line -->
            <template v-slot:item.created_at="{ item }">
                {{ item.created_at | datetime }}
            </template>
            <!-- eslint-disable-next-line -->
            <template v-slot:item.jugadas="{ item }">
                {{ item.jugada_list.length }}
            </template>
            <!-- eslint-disable-next-line -->
            <template v-slot:item.total_ganado="{ item }">
                <v-chip :outlined="!ui.isDark || !(ui.isDark && item.cantidad_premio)" small label :color="item.cantidad_premio ? `primary` : ``" class="d-flex justify-center" style="width: 100%">{{ item.cantidad_premio }} - {{ item.premio | currency }}</v-chip>
            </template>
            <!-- eslint-disable-next-line -->
            <template v-slot:item.total="{ item }">
                {{ item.total | currency }}
            </template>
            <!-- eslint-disable-next-line -->
            <template v-slot:item.monto="{item}">
                <v-chip small color="primary" label>
                    {{ params.numero }} - {{ item.jugada_list.find(jugada => jugada.numero == params.numero)?.monto | currency }}
                </v-chip>
            </template>
            <!-- eslint-disable-next-line -->
            <template v-slot:item.state="{ item }">
                <v-chip label v-if="item.state == -1" color="error" small>Anulado</v-chip>
                <v-chip label v-if="item.state == 0" color="primary" small>Vendido</v-chip>
                <v-chip label v-if="item.state == 1" color="accent" small>Ganador</v-chip>
                <v-chip label v-if="item.state == 2" color="success" small>Pagado</v-chip>
            </template>
            <!-- eslint-disable-next-line -->
            <template v-slot:item.fecha="{ item }">
                {{ item.created_at | date }}
            </template>
             <!-- eslint-disable-next-line -->
             <template v-slot:item.actions="{ item }">
                <v-btn color="primary" icon @click="openTicket(item)"><v-icon>mdi-eye</v-icon></v-btn>
            </template>
            
        </v-data-table>
    </v-card>
</template>
<script>
import TicketService from '@services/sistema/TicketService';

export default {
    props: {
        params: {
            defaults: function () {
                return {

                };
            }
        },
    },
    data: function(){
        return {
            options: {},
            list: [],
            count: 0,
            loading :false,
        }
    },
    computed:{
        headers: function () {
            return [
                ... this.params.state == null ? [{
                    text: 'Estado',
                    value: 'state',
                    align: 'center',
                    width: 100
                }]: [],
                {
                    text: 'Control',
                    value: 'general',
                    width: 100
                },
                {
                    text: 'Nº Jugadas',
                    width: 125,
                    value: 'jugadas',
                },
                {
                    text: 'Total',
                    value: 'total',
                    width: 150
                },
                {
                    text: 'Total Ganado',
                    value: 'total_ganado',
                    align: 'center',
                    width: 150
                },
                {
                    text: 'Fecha',
                    value: 'created_at',
                    width: 200
                },
            ];
        },
        divisa: function () {
            return this.$store.getters['persist/divisa/selected'];
        },
    },
    methods:{
        getList: function (params = {}) {
            this.loading = true;
            this.count = 0;
            this.list = [];
            if(!Object.hasOwn(params,'limit')) params = {...params, ...this.getOptions()};
            TicketService.getList({...this.params, ...params, divisa_id: this.divisa.id})
                .then(({ticketList, count}) => {
                    this.list = ticketList;
                    this.count = count;
                }).finally(() => {
                    this.loading = false;
                });
        },
        openTicket: function (ticket) {
            const route = this.$router.resolve({
                name: 'sistema.ticket.view',
                params: {id: ticket.id},
                query: {'no-layout': 1}
            });
            window.open(new URL(route.href, window.location.origin), '_blank', 'titlebar=no, status=no, menubar=no, height=520 width=680');
        },
        getOptions: function () {
            const params = {};
            let itemsPerPage = null;
            if (this.options.itemsPerPage !== -1) itemsPerPage = this.options.itemsPerPage
            else if (this.count) itemsPerPage = this.count
            params['limit'] = itemsPerPage;
            params['offset'] = (this.options.page * itemsPerPage) - itemsPerPage;
            return params;
        },
    },
    watch: { 
        'params': function() {
            this.getList();
        },
        divisa: function () {
            this.getList();
        },
        options: {
            handler: function () {
                this.getList(this.getOptions()); 
            },
            deep: true,
        },
    }
}
</script>
<tyle>

</tyle>